module.exports = __webpack_public_path__ + "assets/img/icon-drift.e5786c9c.png";